import React, { useEffect, useState } from 'react';
import { Priority, CustomerPriority as CustomerPriorityEntry } from '../../types/customer';
import ListViewWithModal from '../Common/ListViewWithModal';
import { usePriorities } from '../../hooks/useToolboxHooks';
import { useAddCustomerPriorityMutation, useDeleteCustomerPriorityMutation, useFetchCustomerPriorities } from '../../hooks/customer-hooks';


interface CustomerPriorityProps {
  customerID: string | number;
}

const CustomerPriority: React.FC<CustomerPriorityProps> = ({ customerID }) => {
  const { priorities, lookup, loading, error } = usePriorities();
  const { data: customerPriorityEntries } = useFetchCustomerPriorities({customer: customerID as string }, { enabled: !!customerID });
  const [customerPriorities, setCustomerPriorities] = useState<(Priority & { customerEntry?: number })[]>([]);
  const { mutate: addCustomerPriority } = useAddCustomerPriorityMutation();
  const { mutate: deleteCustomerPriority } = useDeleteCustomerPriorityMutation();

  useEffect(() => {
    if (!customerPriorityEntries?.length || !priorities?.length) {
      setCustomerPriorities([]);
      return;
    }

    for (const entry of customerPriorityEntries) {
      const filteredPriorities = customerPriorityEntries.map((p: CustomerPriorityEntry) => ({ ...lookup[p.priority] as Priority, customerEntry: p.id }))
      setCustomerPriorities(filteredPriorities);
    }
  }, [priorities, customerPriorityEntries, lookup]);

  if (loading) return <div>Loading priorities...</div>;
  if (error) return <div>Error loading priorities: {error}</div>;

  return (
    <ListViewWithModal<Priority & { customerEntry?: number }>
      title="Priorities"
      items={customerPriorities}
      availableItems={priorities}
      onAddItem={(item) => addCustomerPriority({ customer: customerID as string, priority: item.id })}
      onDeleteItem={(id) => deleteCustomerPriority({ customer: customerID as string, id: customerPriorities.find(p => p.id.toString() === id)?.customerEntry })}

      idKey="id"
      nameKey="name"
      descriptionKey="description"
    />
  );
};

export default CustomerPriority;